import { motion } from "framer-motion";
import { Check } from "lucide-react";
import Reveal from "@/components/Reveal";
import { LIFESTYLE_IMAGE } from "@/data";

const CHAPTERS = [
  { n: "01", title: "Tonifier", text: "Les vibrations sollicitent vos muscles en profondeur. En dix minutes par jour, votre silhouette se raffermit, en douceur." },
  { n: "02", title: "Faire circuler", text: "La vibration douce stimule la circulation et apporte cette sensation de jambes légères que vous allez adorer." },
  { n: "03", title: "Se relaxer", text: "Après une longue journée, laissez les tensions se dissoudre. Votre moment de calme, rien qu'à vous." },
];

export default function Manifesto() {
  return (
    <section className="vf-manifesto" id="benefits">
      <div className="vf-manifesto-inner">
        <Reveal>
          <p className="vf-kicker">Le manifeste</p>
          <h2 className="vf-h2">Pourquoi vous allez<br /><em>l&apos;adorer.</em></h2>
        </Reveal>
        <div className="vf-chapters">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.12} className="vf-chapter">
              <span className="vf-chapter-num">{c.n}</span>
              <h3>{c.title}</h3>
              <p>{c.text}</p>
            </Reveal>
          ))}
        </div>
        <div className="vf-feature">
          <Reveal className="vf-feature-img">
            <motion.img src={LIFESTYLE_IMAGE} alt="Femme profitant d'un moment bien-être à domicile" initial={{ scale: 1.15 }} whileInView={{ scale: 1 }} viewport={{ once: true }} transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }} data-testid="lifestyle-benefit-image" />
            <div className="vf-feature-caption">Votre nouvelle routine<br /><b>commence ici.</b></div>
          </Reveal>
          <Reveal className="vf-feature-copy" delay={0.15}>
            <h3>Simplement <em>à la maison.</em></h3>
            <p>La plateforme VibeFit s&apos;intègre naturellement à votre quotidien. Placez-la devant votre série préférée, utilisez-la après une journée chargée, ou commencez la matinée avec quelques minutes rien que pour vous.</p>
            <ul>
              <li><Check size={16} /> 50 niveaux de vibration réglables</li>
              <li><Check size={16} /> Télécommande incluse</li>
              <li><Check size={16} /> Élastiques de résistance inclus</li>
              <li><Check size={16} /> Surface antidérapante et silencieuse</li>
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
